export const ACT_RECORD_FIELD_NAMES = {
  date: 'date',
  number: 'number',
  regPlace: 'reg_place'
};

export const CHANGE_ACT_RECORD_FIELD_NAMES = {
  changed: 'changed',
  type: 'act_rec_type',
  date: 'act_rec_date',
  number: 'act_rec_num',
  regPlace: 'reg_office_name'
};

export const ACT_RECORD_CHANGE_TYPES = {
  nameChange: 'NAME_CHANGE_RECORD',
  marriage: 'MARRIAGE_RECORD',
  divorce: 'CERTIFICATE_OF_DIVORCE'
};

export const ACT_RECORD_TYPES = {
  [ACT_RECORD_CHANGE_TYPES.nameChange]: {
    value: ACT_RECORD_CHANGE_TYPES.nameChange,
    text: 'Актовая запись о перемене имени'
  },
  [ACT_RECORD_CHANGE_TYPES.marriage]: {
    value: ACT_RECORD_CHANGE_TYPES.marriage,
    text: 'Актовая запись о заключении брака'
  },
  [ACT_RECORD_CHANGE_TYPES.divorce]: {
    value: ACT_RECORD_CHANGE_TYPES.divorce,
    text: 'Актовая запись о расторжении брака'
  }
};

export const ACT_RECORD_NUMBER_REGEXP = {
  FROM_INPUT_MASK: '[0-9]{21}',
  FROM_VALIDATOR: /^[0-9]{21}$/i
};

export const ACT_RECORD_NUMBER_OLD_REGEXP = {
  FROM_INPUT_MASK: '(([0-9]{1,5})|([0-9]{1,5}[-][BВ])|([0-9]{21}))', // Литера В - кириллицей и латиницей
  FROM_VALIDATOR: /(^[0-9]{1,5}((-B)|(-В))*$)|(^[0-9]{21}$)/i
};
